var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToPlanLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ZumPlan",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 74,
    viewBox: "0 0 65 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #ZumPlan .cls-1 {\n        fill: #c5d75d;\n      }\n\n      #ZumPlan .cls-2 {\n        fill: #fff;\n      }\n\n      #ZumPlan .cls-3 {\n        fill: url(#linear-gradient);\n      }\n\n      #ZumPlan .cls-4 {\n        filter: url(#Pfad_2706);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_2706",
    x: 0,
    y: 0,
    width: 65,
    height: 74,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.08,
    y1: 0.251,
    x2: 0.196,
    y2: 0.622,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33bc12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c5d75d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4",
    transform: "matrix(1, 0, 0, 1, -9, -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2706-2",
    "data-name": "Pfad 2706",
    className: "cls-1",
    d: "M0,0H47V33A23,23,0,0,1,24,56H23A23,23,0,0,1,0,33Z",
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2707",
    "data-name": "Pfad 2707",
    className: "cls-2",
    d: "M44.158,27.413l-1.459.352A19.752,19.752,0,1,1,20.56,12.882L20.34,11.4A21.233,21.233,0,1,0,44.158,27.413"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2708",
    "data-name": "Pfad 2708",
    className: "cls-2",
    d: "M28.664,35.374a14.915,14.915,0,0,0-6.937-3.7,14.926,14.926,0,0,0,3.7,6.937,14.926,14.926,0,0,0,6.937,3.705,14.915,14.915,0,0,0-3.7-6.937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2709",
    "data-name": "Pfad 2709",
    className: "cls-2",
    d: "M34.264,32.028a13.241,13.241,0,0,0,6.7-3.342,13.243,13.243,0,0,0,3.343-6.7A13.251,13.251,0,0,0,37.6,25.324a13.25,13.25,0,0,0-3.341,6.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2705",
    "data-name": "Pfad 2705",
    className: "cls-3",
    d: "M33.314,46.543A17.207,17.207,0,0,1,11.163,20.362l2.586,2.373a13.75,13.75,0,0,0-2.3,15.968Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2710",
    "data-name": "Pfad 2710",
    className: "cls-2",
    d: "M23.858,17.148c-1.162,1.242-.721,2.239.979,2.216a3.1,3.1,0,0,1,.649.062l2.447-3.072a4.48,4.48,0,1,1,8.595-1.769,4.493,4.493,0,0,1-2.037,3.748v4.688a2.543,2.543,0,0,1,.213.162c1.241,1.162,2.238.721,2.215-.979a3.176,3.176,0,0,1,3.048-3.194c1.7-.057,2.094-1.072.875-2.259a3.177,3.177,0,0,1-.1-4.414c1.162-1.241.722-2.238-.979-2.215a3.175,3.175,0,0,1-3.193-3.049c-.057-1.7-1.073-2.092-2.259-.874a3.174,3.174,0,0,1-4.414.1c-1.241-1.161-2.239-.721-2.216.979a3.173,3.173,0,0,1-3.048,3.194c-1.7.057-2.093,1.074-.874,2.259a3.175,3.175,0,0,1,.1,4.414"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2711",
    "data-name": "Pfad 2711",
    className: "cls-2",
    d: "M33.49,17.746a3.483,3.483,0,1,0-4.366-1.28L19.933,28,11.61,38.45a13.475,13.475,0,0,1,2.319-15.542.247.247,0,0,0,.07-.181.251.251,0,0,0-.081-.177l-2.585-2.373a.25.25,0,0,0-.346.008A17.457,17.457,0,0,0,33.46,46.746a.249.249,0,0,0,.058-.348c-.007-.01-.02-.009-.028-.018V17.746ZM6.374,32.528a16.837,16.837,0,0,1,4.8-11.819l2.22,2.038A14,14,0,0,0,11.23,38.82a.244.244,0,0,0,.158.12.16.16,0,0,0,.26,0l8.631-9.452.318.254a.945.945,0,0,0,1.328-.151l9.018-11.319V32.743a.945.945,0,0,0,.945.945h.406l.854,12.665A16.957,16.957,0,0,1,6.374,32.528"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToPlanLogo);
export default __webpack_public_path__ + "static/media/to-plan-logo.aad10d2d510372f652a97cce4360a7c3.svg";
export { ForwardRef as ReactComponent };